import icons from "helpers/icons";
import scss from "./AddToCardButton.module.scss";
import LoadingWrapper from "../../Loading/LoadingWrapper";
import { useTranslation } from "react-i18next";

const AddToCartButton = ({ onClick, type = "button", short = true, className, product, productVariant, location, loading, translateKey }) => {
    const { t } = useTranslation();

    return (
        <>
            <button disabled={loading ? true : false} style={{ zIndex: `1` }} className={`btn-basic relative btn-basic-secondary ${scss.button} ${className}`} type={type} onClick={onClick}>
                <LoadingWrapper isLoading={loading} type="spin" size={20} color={"#fff"} className={loading ? `${scss.loading}` : `${scss.wrapper} ${scss.wrappernopadding}`}></LoadingWrapper>
                <div className={loading ? scss.loading2 : ``}>
                    <span>
                        {productVariant ? (
                            productVariant?.inventory?.inventory_defined && productVariant?.price?.price_defined ? (
                                short ? (
                                    t(`${translateKey}-cart_short`)
                                ) : (
                                    t(`${translateKey}-cart_long`)
                                )
                            ) : (
                                <span
                                // onClick={() => {
                                //     productVariant ? navigate(`/kontakt?slug=${productVariant?.basic_data?.slug}`) : navigate(`/kontakt?slug=${product?.id}`);
                                // }}
                                >
                                    {t(`${translateKey}-contact_link`)}
                                </span>
                            )
                        ) : product?.inventory?.inventory_defined && product?.price?.price_defined ? (
                            short ? (
                                t(`${translateKey}-cart_short`)
                            ) : (
                                t(`${translateKey}-cart_long`)
                            )
                        ) : (
                            <span
                            // onClick={() => {
                            //     navigate(`/kontakt?slug=${product?.id}`);
                            // }}
                            >
                                {t(`${translateKey}-contact_link`)}
                            </span>
                        )}
                    </span>
                    <img src={icons.cart} alt="" />
                </div>
            </button>
        </>
    );
};

export default AddToCartButton;
